import { Form, Input, Button, Row, Col, Select, Card, Layout } from 'antd'
import { useEffect, useState } from 'react'
import Changelist from '../Compare/Changelist'
import { useLocation, useHistory } from 'react-router'
import { useQuery } from 'Hooks'
import { MergeRequest } from 'Model'

{ TextArea } = Input

export default ->

  [branches, setBranches] = useState([])
  [source, setSource] = useState()
  [target, setTarget] = useState()
  [comparable, setComparable] = useState(false)
  [comparing, setComparing] = useState(false)
  [diffs, setDiffs] = useState({})
  [saving, setSaving] = useState(false)

  history = useHistory()
  { pathname } = useLocation()
  query = useQuery()

  useEffect(->
    (->
      setBranches(_.filter(await Weaver.Branch.list(), (branch) -> branch.id() isnt '$config'))
      setSource(qSource) if (qSource = query.get('source'))
      setTarget(qTarget) if (qTarget = query.get('target'))
      setComparing(true) if source? and target?
    )()
    undefined
  , [])

  useEffect(->
    if (source? and target?) and source isnt target
      setComparable(true)
    else
      setComparable(false)
    undefined
  , [source, target])

  branchOptions = (type) ->
    branches.map((branch) ->
      <Select.Option
        key={branch.id()}
        value={branch.id()}
        data-testid="#{type}-#{branch.id()}"
      >
        { branch.name() }
      </Select.Option>
    )

  createMR = ({ title, description }) ->
    setSaving(true)
    mr = new MergeRequest()
    mr.setTitle(title)
    mr.setDescription(description)
    mr.setSource(source)
    mr.setTarget(target)
    mr.setStatus('open')
    mr.setCreator(Weaver.getInstance().currentUser().id())
    await mr.save({ commitMessage: "Create Merge Request."})
    history.push(pathname.replace('new', mr.id()))

  <Layout style={{ padding: '16px' }}>
    <Card>
      {
        unless comparing
          <>
            <Row style={{ marginBottom: '16px' }} gutter={16}>
              <Col lg={12}>
                <Select
                  data-testid="source-branch"
                  showSearch
                  value={source}
                  data-testid="source-branch"
                  placeholder="Source branch"
                  style={{ width: '100%' }}
                  onChange={(value) ->
                    setSource(value)
                  }
                >
                  { branchOptions('source') }
                </Select>
              </Col>
              <Col lg={12}>
                <Select
                  showSearch
                  value={target}
                  data-testid="target-branch"
                  placeholder="Target branch"
                  style={{ width: '100%' }}
                  onChange={(value) ->
                    setTarget(value)
                  }
                >
                  { branchOptions('target') }
                </Select>
              </Col>
            </Row>
            <Button
              type="primary"
              disabled={not comparable}
              data-testid="compare-branches"
              onClick={->
                history.push("#{pathname}?source=#{source}&target=#{target}")
                setComparing(true)
              }
            >
              Compare and continue
            </Button>
          </>
        else
          <>
            <Form
              layout="vertical"
              onFinish={createMR}
              initialValues={{
                title: "Merge #{source} into #{target}"
              }}
            >
              <Form.Item
                label="Title"
                name="title"
                data-testid="mr-title"
                rules={[{ required: true, message: 'A merge request title is required' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
                data-testid="mr-description"
              >
                <TextArea />
              </Form.Item>
              <Form.Item>
                <Button
                  data-testid="save-mr"
                  loading={saving}
                  htmlType="submit"
                  type="primary"
                >
                  Submit merge request
                </Button>
              </Form.Item>
            </Form>
            <Card type="inner" title="Changes">
              <Changelist source={source} target={target} />
            </Card>
          </>
      }
    </Card>
  </Layout>
